import Slick from 'vue-slick';

export default {

  name: 'slider-block',

  props: {
    block: {}
  },

  components: { 'coe-slider': Slick },

  data () {
    return {
      slickSliderOptions: {
        lazyLoad: 'ondemand',
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 4000,
        infinite: true,
        fade: true,
        arrows: true,
        dots: true,
        responsive: [
          {
            breakpoint: 1024,
            settings: {
              arrows: false,
              dots: false
            }
          }
        ]
      }
    };
  }
};



// WEBPACK FOOTER //
// ./src/apps/booking/components/pageBuilder/pageBuilderBlock/types/sliderBlock/SliderBlock.js